import { render } from "./CulturaHeroSection.vue?vue&type=template&id=6b634c98&scoped=true"
import script from "./CulturaHeroSection.vue?vue&type=script&lang=js"
export * from "./CulturaHeroSection.vue?vue&type=script&lang=js"

import "./CulturaHeroSection.vue?vue&type=style&index=0&id=6b634c98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b634c98"]])

export default __exports__